<template>
  <vetalfa-panel
    :value="value"
    title="Todas as seções"
    subtitle="Conteúdos e suporte clínico disponíveis."
    @input="$emit('input', $event)"
  >
    <div
      v-for="group in groups"
      :key="`sections-group-${group.id}`"
      class="va-sections-group"
    >
      <h3 class="va-sections-group-title">{{ group.title }}</h3>
      <div class="va-home-grid va-panel-grid" :style="gridStyle">
        <vetalfa-section-row
          v-for="section in group.items"
          :key="`sections-${section.id || section.name}`"
          :section="section"
          full-name
          :show-pro="!isPremium && !!section.pro"
          @select="select(section)"
        ></vetalfa-section-row>
      </div>
    </div>
  </vetalfa-panel>
</template>

<style>
.va-sections-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.va-sections-group-title {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7a90;
}

.va-panel-grid {
  gap: 8px;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import VetalfaPanel from "@/components/VetalfaPanel.vue";
import SectionRow from "@/components/home/SectionRow.vue";
import sectionsEnum from "@/constants/sections.enum.js";

export default {
  name: "AllSectionsPanel",
  components: {
    "vetalfa-panel": VetalfaPanel,
    "vetalfa-section-row": SectionRow,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("general", ["isPremium", "toggles"]),
    /** Grupos vêm do catálogo; o componente não mantém lista própria. */
    groups() {
      return sectionsEnum.getContentSectionGroups(this.toggles);
    },
    /**
     * Coluna nunca fica estreita demais para o nome mais longo
     * ("Diagnósticos diferenciais", "Interações medicamentosas").
     * No mobile, uma coluna; no desktop, quantas couberem com 220px.
     */
    gridStyle() {
      return {
        gridTemplateColumns: this._isMobile()
          ? "minmax(0, 1fr)"
          : "repeat(auto-fit, minmax(220px, 1fr))",
      };
    },
  },
  methods: {
    ...mapActions("general", ["logEvent"]),
    select(section) {
      this.logEvent({
        name: "home_all_sections_click",
        object: { id: section.id || section.icon },
      });
      this.$emit("input", false);
      sectionsEnum.goToSection({ section, dispatch: this.$store.dispatch });
    },
  },
};
</script>
